// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KeywordController from "./keyword_controller"
application.register("keyword", KeywordController)

import ManifestationsController from "./manifestations_controller"
application.register("manifestations", ManifestationsController)

import ResearcherNetworkController from "./researcher_network_controller"
application.register("researcher-network", ResearcherNetworkController)
